import { SortOrder, GetRepairRequestList } from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export interface RepairRequestListParam {
  rmaNo: string;
  serialNo: string;
  status: number;
  sortKey?: string;
  order?: SortOrder;
  rowFrom: number;
  perPage: number;
}

const endPoint = 'repair-request/list';

export const fetchRepairRequestList = async (
  params: RepairRequestListParam,
): Promise<GetRepairRequestList> => {
  const queryParams = new URLSearchParams();

  if (params.rmaNo !== '') {
    queryParams.append('rmaNo', params.rmaNo);
  }
  if (params.serialNo !== '') {
    queryParams.append('serialNo', params.serialNo);
  }
  if (params.status !== 2) {
    queryParams.append('status', params.status.toString());
  }
  if (params.sortKey) {
    queryParams.append('sortKey', params.sortKey);
  }
  if (params.order) {
    queryParams.append('order', params.order);
  }
  if (params.rowFrom !== undefined) {
    queryParams.append('rowFrom', params.rowFrom.toString());
  }
  if (params.perPage !== undefined) {
    queryParams.append('perPage', params.perPage.toString());
  }

  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};
